import moment from 'moment';
import {useMemo} from 'react';

import {APP_NAME} from 'constants/app';

export const Copyright: React.FC = () => {
    const currentYear = useMemo(() => moment().year(), []);
    return <span>{`© ${currentYear} ${APP_NAME}, Inc.`}</span>;
};